<script setup>
import CFLockedTeamBanner from '@/shared/components/CFLockedTeamBanner.vue';
import CFUnverifiedTeamBanner from '@/shared/components/CFUnverifiedTeamBanner.vue';
import CFRequired2FABanner from '@/shared/components/CFRequired2FABanner.vue';
import { useTeamStore } from '#modules/team/stores/team.store.js';
import { useAccountStatus } from '@/shared/composables/useAccountStatus.js';
import { computed, nextTick, onBeforeUnmount, onMounted, useTemplateRef, watch } from 'vue';

const teamStore = useTeamStore();
const { shouldEnforceTFA } = useAccountStatus();
const header = useTemplateRef('header');

const showHeader = computed(() => {
    return (
        shouldEnforceTFA.value ||
        (teamStore.hasRequiredInformation && !teamStore.isVerified) ||
        (teamStore.hasRequiredInformation && !teamStore.isUnlocked)
    );
});

watch(showHeader, (show) => {
    let element = document.getElementById('cyberfusion');

    if (!element) {
        return;
    }

    nextTick(() => {
        if (show) {
            element.style.paddingTop = `${header.value.clientHeight}px`;
        } else {
            element.style.paddingTop = '0px';
        }
    });
});

onMounted(() => {
    if (!showHeader.value || !header.value) {
        return;
    }

    // Adjust the padding of the cyberfusion wrapper to account for the header height
    document.getElementById('cyberfusion').style.paddingTop = `${header.value.clientHeight}px`;
});

onBeforeUnmount(() => {
    document.getElementById('cyberfusion').style.paddingTop = '0px';
});
</script>

<template>
    <header
        v-if="showHeader"
        ref="header"
        class="fixed top-0 right-0 left-0 z-100 w-full"
    >
        <CFRequired2FABanner v-if="shouldEnforceTFA" />
        <CFUnverifiedTeamBanner v-else-if="teamStore.hasRequiredInformation && !teamStore.isVerified" />
        <CFLockedTeamBanner v-else-if="teamStore.hasRequiredInformation && !teamStore.isUnlocked" />
    </header>
</template>
